import { Badge } from "@/components/ui/badge";

import { cn, isNew } from "../lib/util.js";

/* 새로 들어온 곳 표식. new_stores.json 에 있으면 붙는다(App 이 _new 를 단다). 자리
   잡았다 싶으면 항목을 stores.json 으로 옮기는 것으로 뗀다.
   **고르는 화면에만** 붙는다 — 목록 카드와 겹친 핀 목록
   둘이다. 두 자리가 같은 조각을 쓰는 건 같은 표식이 화면마다 다르게 생기면 같은 것인
   줄 모르기 때문이다(WantMark 와 같은 이유).

   한 곳짜리 말풍선과 리뷰 시트에는 안 붙인다. 거기까지 갔으면 이미 그 집을 고른
   뒤라 '훑다가 걸리게 한다'는 이 배지의 일이 끝났고, 268px 짜리 말풍선에서는
   긴 이름 뒤에 붙은 배지가 하트를 아랫줄로 밀어냈다.

   판정은 여기서 하지 않고 isNew(util.js) 한 곳에서만 한다 — 검색어 '신규'를
   거르는 filter.js 도 같은 함수를 본다.

   붙는 자리는 이름 끝의 인라인이다. 하트·×N 과 같은 규칙 — 별도 flex 칸으로 떼면
   이름이 두 줄이 되는 순간 무엇에 붙은 표시인지 모를 자리에 혼자 선다.

   영업시간·배달이 서 있는 흐린 배지줄(StoreList 의 Info)에는 안 넣는다. 그쪽은
   '읽는 것'이라 일부러 눈에 안 걸리게 뒀고, 이건 훑다가 걸려야 하는 표식이다. */
export function NewMark({ store, className }) {
  if (!isNew(store)) return null;

  return (
    <Badge
      className={cn(
        "new-mark bg-primary-soft px-1.5 py-0 align-middle text-[10.5px] font-bold text-primary",
        className,
      )}
    >
      신규
    </Badge>
  );
}
